export enum NOTIFICATION_TYPE{
    primary='primary',
    secondary='secondary',
    success='success',
    danger='danger',
    warning='warning',
    info='info',
    light='light',
    dark='dark'
}